import React, { FC } from 'react';
import cn from 'classnames';
import './styles.scss';

interface IPageTitle {
  title: string;
  bottomLine?: boolean;
  className?: string;
  filters?: JSX.Element;
}

const PageTitle: FC<IPageTitle> = ({ title, bottomLine, className, filters }) => {
  return (
    <section
      className={cn('hbh-page-title', {
        ['hbh-page-title_bottom-line']: bottomLine,
        [String(className)]: !!className,
      })}
    >
      <h1 className='title'>{title}</h1>
      <div className='hbh-filters'>{filters}</div>
    </section>
  );
};

export default PageTitle;
